(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldGenerator', activityFieldGenerator);

    function activityFieldGenerator() {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                title: '=?',
                model: '=',
                onChange: '&?'
            },
            controller: activityFieldGeneratorCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function activityFieldGeneratorCtrl($element, $compile, $scope) {
        var vm = this;
        this.$onInit = function() {
            $element.html(`<activity-field-${vm.element.type} element="vm.element" ng-model="vm.model" title="vm.title" on-change="vm.onChange({name: name, value: value})"></activity-field-${vm.type}>`);
            const cloneElement = $compile($element.contents())($scope);
            $scope.$on('$destroy', () => {
                cloneElement.off();
            });
        }
    }
})();